import * as yup from 'yup';

export const email = yup
	.string()
	.email('Indtast venligst en gyldig email.')
	.required('Påkrævet');
